<!-- 插屏 -->
<template>
    <div class="page-code-add-info sreen">
        <el-form ref="form" :rules="rules" :model="form" label-width="110px" class="form-box">
            <el-form-item label="代码位名称" prop="adslot_name">
                <el-input v-model="form.adslot_name" show-word-limit :maxlength="30" clearable/>
            </el-form-item>
            
            <el-form-item label="所属应用" prop="media_id">
                <el-select
                    v-model="form.media_id"
                    placeholder="请选择"
                    clearable
                    filterable
                    :disabled="!!id"
                    @change="getStyleList"
                >
                    <el-option
                        v-for="item in appOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item label="渲染方式" prop="render_method">
                <el-radio-group v-model="form.render_method">
                    <el-radio-button
                        v-for="item in renderMethodOptions"
                        :key="item.value"
                        :label="item.value"
                    >{{ item.label }}
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
            
            <el-form-item label="屏幕方向" prop="screen_ori">
                <el-radio-group v-model="form.screen_ori">
                    <el-radio-button
                        v-for="item in screenOriOptions"
                        :key="item.value"
                        :label="item.value"
                    >{{ item.label }}
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
            
            <el-form-item label="视频声音" prop="video_sound">
                <el-radio-group v-model="form.video_sound">
                    <el-radio-button
                        v-for="item in videoSoundOptions"
                        :key="item.value"
                        :label="item.value"
                    >{{ item.label }}
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>

            <el-form-item label="竞价类型" prop="bidding_type">
                <el-radio-group
                    v-model="form.bidding_type"
                    @change="handleBiddingTypeChange"
                    :disabled="!!id"
                >
                    <el-radio-button
                        v-for="item in biddingTypeOptions"
                        :key="item.value"
                        :label="item.value"
                    >{{ item.label }}
                    </el-radio-button>
                </el-radio-group>
            </el-form-item>
            <el-form-item
                v-if="+form.bidding_type === 2"
                prop="bid_cpm"
                label="CPM价格"
            >
                <el-input v-model="form.bid_cpm" :disabled="!!id">
                    <span class="unit-text" slot="suffix">元</span>
                </el-input>
            </el-form-item>
            
            <el-form-item>
                <el-button @click="onCancel">取消</el-button>
                <el-button type="primary" @click="onSubmit">提交</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import {getCodeDetail, getAllAppList, getStyleList, doAddCode, doEditCode} from '@/apis/flow.js';
import {RenderMethodModule, AccAdtypes, ScreenOri, BiddingTypes, BiddingTypes2, VideoSound} from '@/common/constant'

export default {
    props: {
        codeType: {
            default: ''
        },
    },
    data() {
        return {
            appOptionsMap: {},
            appOptions: [],
            renderMethodOptions: [
                ...RenderMethodModule
            ],
            accAdtypesOptions: [
                ...AccAdtypes
            ],
            screenOriOptions: [
                ...ScreenOri
            ],
            biddingTypeOptions: [],
            styleOptions: [],
            videoSoundOptions: [
                ...VideoSound
            ],
            rules: {
                adslot_name: [
                    {required: true, message: '代码位名称必填'}
                ],
                media_id: [
                    {required: true, message: '所属应用必选'}
                ],
                render_method: [
                    {required: true, message: '渲染方式必选'}
                ],
                screen_ori: [
                    {required: true, message: '屏幕方向必选'}
                ],
                video_sound: [
                    {
                        required: true,
                        validator(rule, value, callback) {
                            callback();
                        },
                        message: '视频声音必选'
                    }
                ],
                bidding_type: [
                    {required: true, message: '竞价类型必选'}
                ],
                bid_cpm: [
                    {required: true, message: 'CPM价格必填'},
                    {
                        validator(rule, value, callback) {
                            const reg = /^(([1-9]{1}\d*)|(0{1}))(\.\d{1,2})?$/
                            if (reg.test(value) && Number(value) > 0) {
                                callback();
                            } else {
                                callback(new Error("请输入有效数字"));
                            }
                        },
                        message: '仅支持2位小数'
                    },
                ]
            },
            form: {
                media_id: '',
                render_method: RenderMethodModule[0].value,
                screen_ori: ScreenOri[0].value,
                video_sound: VideoSound[0].value,
                bidding_type: BiddingTypes[0].value,
            }
        }
    },
    computed: {
        id() {
            return this.$route.query.id || ''
        },
        appName() {
            return this.$route.query.appName || ''
        },
    },
    created() {
        this.userInfo = this.$ls.get('userInfo');
        this.biddingTypeOptions = this.userInfo.auth.server_bid_auth ? BiddingTypes2 : BiddingTypes;
        this.getAllAppList()
        if (this.id) {
            this.getDetail()
        }
    },
    methods: {
        async getDetail() {
            const {data = {}} = await getCodeDetail({
                id: this.id
            })
            this.form = {
                ...this.form,
                ...data,
            }
            this.getStyleList()
        },
        
        async getAllAppList() {
            const {data = []} = await getAllAppList({ status: 0 })
            this.appOptions = data
            if (!this.id && !this.form.media_id && data.length === 1) {
                this.form.media_id = data[0].id
            }
            data.forEach(item => {
                this.appOptionsMap[item.id] = item.name
                if (!this.id && item.name === this.appName) {
                    this.form.media_id = item.id
                }
            })
            if (this.form.media_id) {
                this.getStyleList()
            }
        },
        
        async getStyleList() {
            const {data = []} = await getStyleList({
                media_id: this.form.media_id,
                screen_ori: this.form.screen_ori,
                adslot_type: this.codeType
            });
            this.styleOptions = data;
        },
        
        handleBiddingTypeChange() {
            this.$delete(this.form, 'bid_cpm')
        },
        
        onCancel() {
            this.$router.go(-1);
        },
        
        async onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    if (this.id) {
                        const {message = '编辑成功'} = await doEditCode({
                            ...this.form,
                            id: this.id,
                            type: this.codeType
                        })
                        this.$message.success(message)
                    } else {
                        const {message = '创建成功'} = await doAddCode({
                            ...this.form,
                            type: this.codeType
                        })
                        this.$message.success(message)
                    }
                    this.$router.go(-1);
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss">
.page-code-add-info {
    &.sreen {
        .label-input-box {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 70px;
            height: 40px;
            border-radius: 4px;
            border: 1px solid #4F90FF;
            background-color: #F3F9FF;
            color: #4F90FF;
            
            .btn-input {
                margin-right: 3px;
                width: 20px;
                border-bottom: 1px solid #CACED4;
                height: 20px;
                line-height: 20px;
                
                .el-input__inner {
                    padding: 0;
                    border: none;
                    width: 20px;
                    height: 20px;
                    background-color: transparent;
                    line-height: 20px;
                    text-align: center;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #4F90FF;
                }
            }
        }
    }
}
</style>
